import { memo } from 'react';

import {
  ChakraBox,
  ChakraVStack,
  CheckboxV2,
  EditorV2,
  Text,
} from '@equip.health/ui';

import { NoteInfoValue } from '~/components/common/inquiry/drawer/types';
import './InquiryNote.css';

const TOP_LEVEL_ID = 'inquiry-note';

interface InquiryNoteProps {
  noteValue: NoteInfoValue;
  setNoteValue: React.Dispatch<Partial<NoteInfoValue>>;
}

const InquiryNote = memo(({ noteValue, setNoteValue }: InquiryNoteProps) => {
  const { content } = noteValue;

  return (
    <ChakraVStack align="flex-start" className={TOP_LEVEL_ID} gap="24px">
      <Text color="neutral.primary" variant="h5">
        Note
      </Text>
      <ChakraBox width="100%">
        <EditorV2
          initialContent={content}
          minHeight="calc(100vh - 250px)"
          onChange={(value) => setNoteValue({ content: value })}
        />
      </ChakraBox>
      <CheckboxV2
        id={TOP_LEVEL_ID}
        label="Mark as qualifying call note"
        onChange={(val: boolean) => setNoteValue({ isQualifyingCall: val })}
      />
    </ChakraVStack>
  );
});

export default InquiryNote;
